<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <!-- <el-button type="primary" @click="startCreate()" size="mini">添加资产</el-button> -->
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId" placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="list-title">
      <el-row>
        <!-- <el-col :span="8">
          <el-input v-model="filterKey" size="mini" placeholder="你可以输入筛选资产编号/使用人"></el-input>
        </el-col> -->
      </el-row>
    </div>

    <el-table :data="paginationData" style="width: 100%">
      <el-table-column label="维修单号" width="120px">
        <template slot-scope="scope">
          <a style="color: #175177;text-decoration: underline;" href="javascript:void(0)" @click="assetDetail(scope.row)">{{scope.row.number}}</a>
        </template>
      </el-table-column>
      <!-- changeAssets -->
      <el-table-column label="维修资产">
        <template slot-scope="scope">
          <span v-html="scope.row.assets.map(item=>item.name).join()"></span>
          <!-- {{scope.row.changeAssets}} -->
        </template>
      </el-table-column>


      <el-table-column label="报修人" width="160px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.repairer'></user-info>
        </template>
      </el-table-column>

      <el-table-column prop="repairTime" label="报修时间" width="100px">
      </el-table-column>
      <el-table-column label="维修状态" width="100px">
        <template slot-scope="scope">
          {{ scope.row.repairStatusCode ==0?"维修中":"已完成" }}
        </template>
      </el-table-column>


      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="assetDetail(scope.row)">详情</el-button>
          <el-button plain type="success" size="mini" @click="assetEdit(scope.row)">情况跟踪</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <asset-repair-detail></asset-repair-detail>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  import AssetRepairDetail from './assetRepairDetail'
  export default {
    mixins: [Role],
    components: {
      AssetRepairDetail,
      UserInfo,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        repairDetailStatus: false,
        repairDetailData: '',

        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表
        loading: true,
        pageSize: 50,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        teamId: 0,
        filterKey: "",
        teamArr: [],

        // 表格多选
        multipleSelection: []
      }
    },
    mounted() {
      console.log(this.organization.length > 0)

      this.organizationListData.push({
        id: 0,
        name: "集团所有公司",
        depId: 0
      })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7" || this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
        this.depId = 0
      }

      // 获取列表
      // this.getLists()
      // 获取项目组
      // this.getTeam()
    },
    methods: {
      // 维修编辑
      assetEdit(row) {
        this.$store.commit('set_assetRepair', {
          type: 1,
          data: row.assets
        })
        this.$router.push('/Asset/Repair/' + row.id)
      },

      // 隐藏详情
      hideRepairDetail() {
        this.repairDetailStatus = false
      },
      // 显示详情
      assetDetail(row) {
        let assetRepairDetail = {
          status: true,
          data: row
        }
        this.$store.commit('set_assetRepairDetail', assetRepairDetail)
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        console.log(this.filterName)
        if (this.teamId || this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _project = this.listData[i]
            let _filterStatus = true
            if (this.teamId && _project.team && _project.team.id != this.teamId) {
              _filterStatus = false
            }
            if (!_project.team) {
              _filterStatus = false
            }
            if (_filterStatus) {
              if (_project.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _project.leader.name.toLowerCase()
                .indexOf(this.filterKey.toLowerCase()) != -1 ||
                _project.number.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
                this.filterData.push(_project)
              }
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/asset/repair/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'depId'() {
        this.getLists()
      },
      // 'teamId'() {
      //   this.getFilterData()
      // },
      'filterKey'() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/repairList.vue